import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || window.location.origin;
const BASE_URL = API_URL.endsWith('/api') ? API_URL : `${API_URL}/api`;

console.log('Flight Club TV - API Configuration:', {
  API_URL,
  BASE_URL,
  origin: window.location.origin
});

// Create axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

